<template>
  <v-container id="productos" tag="section">
    <base-v-component heading="Producto " />
    <base-material-card
      v-if="!viendoOpciones"
      color="indigo"
      icon="mdi-basket"
      inline
      class="px-5 py-3"
    >
      <v-card-text>
        <v-container grid-list-md>
          <v-row>
            <v-col cols="8">
              <v-row>
                <v-col cols="4">
                  <v-select
                    :items="idiomas"
                    v-model="langSeleccionado"
                    label="Selección idioma"
                    outline
                  ></v-select>
                </v-col>
                <v-col cols="4">
                  <traducciones-dialog
                    :datos="valoresTraducir"
                    @camposTraducidos="camposTraducidos"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <v-text-field
                    v-model="nombreShow"
                    label="Nombre"
                    :error-messages="nombreErrors"
                    @input="$v.nombreValidar.$touch()"
                    @blur="$v.nombreValidar.$touch()"
                    ref="nombreReferencia"
                  ></v-text-field>
                  <v-text-field
                    v-model="nombreTpv"
                    label="Nombre tpv / cocina"
                    messages="si no tiene se utilizará el normal"
                    :counter="21"
                  ></v-text-field>
                  <v-text-field
                    v-model="descripcionInterna"
                    label="Descripción interna"
                    :error-messages="descripcionErrors"
                  ></v-text-field>
                  <v-text-field
                    v-model="codigoLector"
                    label="Código lector"
                  ></v-text-field>
                  <v-select
                    :disabled="!individualPedible"
                    :items="categorias"
                    v-model="categoria"
                    label="Categoria"
                  ></v-select>
                  <v-select
                    :disabled="!individualPedible"
                    :items="categorias"
                    v-model="categoriaTpv"
                    label="Categoria para TPV"
                  ></v-select>
                  <v-text-field
                    v-model="precio"
                    label="Precio global"
                    type="number"
                    append-icon="mdi-currency-eur"
                    step="0.5"
                  />
                  <v-autocomplete
                    :disabled="!individualPedible || porPeso"
                    label="Grupo Modificador"
                    :items="gruposModificadores"
                    v-model="grupoModificador"
                  />
                  <v-btn
                    v-if="!!grupoModificador"
                    small
                    @click="
                      $router.push(
                        '/admin/gest/' +
                          negocio.id +
                          '/almacen/gruposmodificadores/form/' +
                          grupoModificador
                      )
                    "
                  >
                    <v-icon color="primary"> mdi-open-in-new </v-icon>
                  </v-btn>
                  <v-btn
                    v-else
                    small
                    @click="crearModificadorAbrirDialog"
                    :disabled="!individualPedible"
                  >
                    CREAR MODIFICADOR
                  </v-btn>
                </v-col>
                <v-col cols="6">
                  <v-textarea
                    v-model="descripcionShow"
                    label="Descripción"
                    :error-messages="descripcionErrors"
                    @input="$v.descripcionValidar.$touch()"
                    @blur="$v.descripcionValidar.$touch()"
                    rows="4"
                  ></v-textarea>
                  <v-select
                    v-model="caractSeleccionadas"
                    :items="caracteristicas"
                    chips
                    label="Características"
                    multiple
                    hint="Que tiene el producto?"
                    persistent-hint
                  >
                    <!-- Template for render selected data -->
                    <template slot="selection" slot-scope="data">
                      <v-chip
                        :input-value="data.selected"
                        close
                        class="chip--select-multi"
                        @input="remove(data.item)"
                      >
                        <v-avatar left class="mr-2" size="25px">
                          <img v-bind:src="data.item.img" size="20" />
                        </v-avatar>
                        {{ data.item.text }}
                      </v-chip>
                    </template>
                    <!-- Template for render data when the select is expanded -->
                    <template slot="item" slot-scope="data">
                      <!-- Divider and Header-->
                      <template v-if="noEsObject(data)">
                        <v-list-item-content
                          v-text="data.item"
                        ></v-list-item-content>
                      </template>
                      <template v-else>
                        <v-list-item-avatar>
                          <img v-bind:src="data.item.img" />
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title
                            v-html="data.item.text"
                          ></v-list-item-title>
                          <v-list-item-subtitle
                            v-html="data.item.grupo"
                          ></v-list-item-subtitle>
                        </v-list-item-content>
                      </template>
                      <!-- Normal item -->
                    </template>
                  </v-select>
                  <v-checkbox label="Modificador" v-model="modificador" />
                  <v-checkbox
                    label="Individual Pedible"
                    v-model="individualPedible"
                  />
                  <v-checkbox label="Producto por peso" v-model="porPeso" />
                </v-col>
              </v-row>
            </v-col>
            <!-- imagen -->
            <v-col cols="4">
              <template v-if="!imagenSrc">
                <v-col cols="6">
                  <v-file-input
                    v-if="!imagenSrc"
                    accept="image/*"
                    label="Imagen Logo"
                    v-model="imagen"
                  ></v-file-input>
                </v-col>
              </template>
              <template v-else>
                <v-row no-gutters>
                  <v-col cols="12">
                    <v-img :src="imagenSrc"></v-img>
                  </v-col>
                  <v-row>
                    <v-col cols="12">
                      <v-btn text @click="imagenSrc = null"
                        >Cambiar Imagen</v-btn
                      >
                      <v-checkbox
                        text
                        v-model="ocultarImagen"
                        label="Ocultar imagen"
                        >Ocultar imagen</v-checkbox
                      >
                    </v-col>
                  </v-row>
                </v-row>
              </template>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <!-- <v-card-text>
        <h3>OPCIONES</h3>
        <v-row class="mt-3">
          <v-col cols="12" md="6">
            <v-combobox
              @change="retl"
              outlined
              :search-input.sync="search"
              label="Añadir panel"
              :items="paneles"
            >
              <template v-slot:no-data>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>
                      Sin resultados "<strong>{{ search }}</strong
                      >". Pulse <kbd>enter</kbd> para crear el panel
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template></v-combobox
            >
          </v-col>
        </v-row>
      </v-card-text> -->
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary darken-1 mr-3"
          @click="save(true)"
          :loading="loadingForm"
          >Guardar y volver</v-btn
        >
        <v-btn
          color="primary darken-1"
          @click="save(false)"
          :loading="loadingForm"
          >Guardar</v-btn
        >
      </v-card-actions>
    </base-material-card>
    <admin-producto-opciones v-else></admin-producto-opciones>
    <v-dialog v-model="crearGrupoModificadorDialog" max-width="700px">
      <v-card>
        <v-card-title> Crear un grupo Modificador Nuevo </v-card-title>
        <v-card-text>
          <v-row align="center">
            <v-col cols="12" md="6">
              <v-text-field label="Nombre" v-model="nuevoGrupo.nombre" /></v-col
            ><v-col cols="12" md="6">
              <v-text-field
                label="Descripcion"
                v-model="nuevoGrupo.descripcion"
            /></v-col>
            <v-col cols="12" md="6"
              ><v-autocomplete
                :items="gruposModificadoresBasados"
                v-model="nuevoGrupo.modificadorBasado"
                label="Modificadores basados en"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-btn @click="generarGrupoModificador" color="success"
                >Crear</v-btn
              >
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import { randomString } from '@/utils/utils.js';

  import { validationMixin } from 'vuelidate';
  import { required, minLength } from 'vuelidate/lib/validators';
  import { mapState, mapGetters, mapActions } from 'vuex';
  import TraduccionesDialog from '../../components/admin/TraduccionesDialog.vue';

  export default {
    components: {
      AdminProductoOpciones: () =>
        import('@/components/negocio/ProductoOpciones'),
      TraduccionesDialog,
    },
    mixins: [validationMixin],
    validations: {
      nombreValidar: { required },
      descripcionValidar: { minLength: minLength(4) },
    },
    data() {
      return {
        search: '',
        nuevoGrupo: {
          nombre: '',
          descripcion: '',
          modificadorBasado: null,
        },
        crearGrupoModificadorDialog: false,
        tieneOpciones: false,
        id: null,
        nombreIdiomas: null,
        nombreValidar: '',
        descripcionInterna: '',
        nombreTpv: '',
        codigoLector: '',
        descripcionIdiomas: null,
        descripcionValidar: '',
        categoria: null,
        categoriaTpv: null,
        caractSeleccionadas: [],
        imagen: null,
        imagenSrc: null,
        individualPedible: true,
        porPeso: false,
        grupoModificador: null,
        modificador: false,
        ocultarImagen: false,
        precio: 0,
        loadingForm: false,
        paneles: [],
      };
    },
    watch: {
      modificador(v) {
        if (v && !this.individualPedible) this.categoria = null;
      },
      crearGrupoModificadorDialog(v) {
        if (v) {
          this.nuevoGrupo.nombre = 'Secuencia ' + this.nombreShow;
        }
      },
    },
    computed: {
      valoresTraducir() {
        let traducir = this.keyTraducir.map((k) => {
          return {
            key: k,
            texto: _.get(this, k),
          };
        });
        return traducir;
      },
      keyTraducir() {
        return ['nombreIdiomas', 'descripcionIdioma'];
      },
      gruposModificadoresBasados() {
        return [
          {
            text: 'Generar vacío',
            value: null,
          },
          ...this.gruposModificadoresBruto.map((g) => {
            return {
              text: g.nombre,
              value: g.id,
            };
          }),
        ];
      },
      gruposModificadores() {
        return [
          {
            text: 'Sin modificadores',
            value: null,
          },
          ...this.gruposModificadoresBruto.map((g) => {
            return {
              text: g.nombre,
              value: g.id,
            };
          }),
        ];
      },
      viendoOpciones: {
        get() {
          return this.$store.state.productos.viendoOpciones;
        },
        set(v) {
          this.$store.commit('productos/setViendoOpciones', v);
        },
      },
      accion() {
        return this.id ? 'edit' : 'add';
      },
      isAdd() {
        return this.accion == 'add';
      },
      isEdit() {
        return this.accion == 'edit';
      },
      ...mapState({
        idiomas: 'idiomas',
        gruposModificadoresBruto: (state) =>
          state.productos.gruposModificadores,
        langDefecto: 'langDefecto',
      }),
      langSeleccionado: {
        get() {
          return this.$store.state.langSeleccionado;
        },
        set(v) {
          this.$store.commit('setLangSeleccionado', v);
        },
      },
      ...mapGetters({
        negocio: 'app/negocioGestObj',
        categorias: 'categorias/getCategoriasSelect',
        caracteristicas: 'caracteristicas/getCaracteristicasSelectGrupo',
      }),
      nombreErrors() {
        const errors = [];
        if (!this.$v.nombreValidar.$dirty) return errors;
        !this.$v.nombreValidar.required &&
          errors.push('Nombre idioma por defecto obligatorio.');
        return errors;
      },
      descripcionErrors() {
        const errors = [];
        if (!this.$v.descripcionValidar.$dirty) return errors;
        !this.$v.descripcionValidar.minLength &&
          errors.push('Descripción idioma por defecto demasiado corto.');
        return errors;
      },
      nombreShow: {
        get() {
          let _vm = this;
          // var found = this.nombreIdiomas
          //   ? this.nombreIdiomas.find((e) => e.lang == _vm.langSeleccionado)
          //   : false;

          let found = Array.isArray(this.nombreIdiomas)
            ? this.nombreIdiomas.find((e) => e.lang == _vm.langSeleccionado)
            : { text: this.nombreIdiomas.es };
          return found ? found.text : '';
        },
        set(v) {
          let _vm = this;
          var index = this.nombreIdiomas.findIndex(
            (e) => e.lang == _vm.langSeleccionado
          );
          var defecto = this.nombreIdiomas.find(
            (e) => e.lang == _vm.langDefecto
          );
          this.nombreValidar = defecto.text;
          this.nombreIdiomas[index].text = v;
        },
      },
      descripcionShow: {
        get() {
          let _vm = this;
          var found = Array.isArray(this.descripcionIdiomas)
            ? this.descripcionIdiomas.find(
                (e) => e.lang == _vm.langSeleccionado
              )
            : { text: this.descripcionIdiomas.es };
          return found ? found.text : '';
        },
        set(v) {
          let _vm = this;
          var index = this.descripcionIdiomas.findIndex(
            (e) => e.lang == _vm.langSeleccionado
          );
          var defecto = this.descripcionIdiomas.find(
            (e) => e.lang == _vm.langDefecto
          );
          this.descripcionValidar = defecto.text;
          this.descripcionIdiomas[index].text = v;
        },
      },
      paneles() {
        return this.$store.state.productos.modificadores.map((p) => {
          return {
            text: p.descripcionInterna,
            value: p,
          };
        });
      },
      panelesMostrar() {
        // return this.
      },
    },
    methods: {
      retl(e) {
        panel.add({
          id: e.id,
          opciones: [],
          min: null, //se toma el global,
          max: null,
        });
      },
      camposTraducidos(r) {
        console.log(r);
        r.forEach((trad) => {
          _.set(this, trad.value, trad.texto);
        });
      },
      generarGrupoModificador() {
        var modificadores = [];
        if (this.nuevoGrupo.modificadorBasado) {
          let f = this.gruposModificadoresBruto.find(
            (g) => g.id === this.nuevoGrupo.modificadorBasado
          );
          if (f) {
            modificadores = f.modificadores.map((mod) => {
              return {
                ...mod,
                opciones: mod.opciones.map((op) => {
                  return {
                    ...op,
                    id:
                      randomString(4) +
                      '_' +
                      op.id.substr(op.id.indexOf('_') + 1), //cambiamos el prefijo
                    incompatibilidades: [],
                  };
                }),
              };
            });
          }
        }
        console.log(modificadores);
        this.$store
          .dispatch('productos/addGrupoModificador', {
            id: null,
            nombre: this.nuevoGrupo.nombre,
            descripcion: this.nuevoGrupo.descripcion,
            modificadores: modificadores,
          })
          .then(async (r) => {
            this.$store.commit('snackbar/setMensajeSuccess', {
              msj: 'Grupo Modificador guardado',
            });
            this.nuevoGrupo = {
              nombre: '',
              descripcion: '',
              modificadorBasado: null,
            };
            await this.$store.dispatch('productos/getGruposModificadores');
            this.grupoModificador = r.id;
            this.crearGrupoModificadorDialog = false;

            return this.save();
          });
      },
      crearModificadorAbrirDialog() {
        this.crearGrupoModificadorDialog = true;
      },
      noEsObject(data) {
        return typeof data.item !== 'object';
      },
      goListado() {
        let str = '/admin/gest/' + this.negocio.id + '/almacen/productos/';
        this.$router.push(str);
      },
      mostrarIdioma(s) {
        let mostrar = s.find((e) => e.lang == this.langDefecto);
        return mostrar.text;
      },
      addProducto(volver = false) {
        let ordenProximoArray = this.$store.getters[
          'productos/getProductosListado'
        ]
          .filter(
            (p) =>
              p.individualPedible && p.categoria == this.categoria && !!p.orden
          )
          .sort((a, b) => a.orden - b.orden);
        let ordenProximo =
          ordenProximoArray.length > 0
            ? ordenProximoArray[ordenProximoArray.length - 1].orden + 1
            : 0;
        console.log(ordenProximo);
        // return Promise.resolve();
        let producto = {
          categoria: this.categoria,
          categoriaTpv: this.categoriaTpv,
          caractSeleccionadas: this.caractSeleccionadas
            ? this.caractSeleccionadas
            : [],
          descripcion: this.descripcionIdiomas,
          paneles: this.paneles,
          descripcionInterna: this.descripcionInterna,
          nombreTpv: this.nombreTpv,
          codigoLector: this.codigoLector,
          nombre: this.nombreIdiomas,
          // tieneOpciones: this.tieneOpciones,
          // opciones: !!this.$store.state.productos.opcionesEditadas ? ,
          precioGlobal: this.precio,
          ocultarImagen: this.ocultarImagen,
          modificador: this.modificador,
          individualPedible: this.individualPedible,
          porPeso: this.porPeso,
          grupoModificador: this.grupoModificador,
          id: this.id ? this.id : null,
          orden: this.orden ? this.orden : ordenProximo,
        };
        if (this.imagen) {
          producto.imagen = this.imagen;
        }
        let _vm = this;
        return this.$store
          .dispatch('productos/addProducto', producto)
          .then((r) => {
            console.log(r);
            if (this.isAdd) {
              let str =
                '/admin/gest/' +
                this.negocio.id +
                '/almacen/productos/edit/' +
                r.id;
              this.id = r.id;
              // this.$router.push(str);
            }
            if (volver) _vm.goListado();
          });
      },
      save(volver = false) {
        let _vm = this;
        this.$v.$touch();
        if (!this.$v.$invalid) {
          this.loadingForm = true;
          this.addProducto(volver)
            .then((res) => {
              _vm.$store.commit('snackbar/setMensajeSuccess', {
                msj: 'Producto guardado con éxito',
              });
            })
            .catch((error) => {
              console.log(error);
              _vm.$store.commit('snackbar/setMensajeDanger', {
                msj: 'Error al guardar el producto',
              });
            })
            .finally(() => {
              _vm.loadingForm = false;
            });
        }
      },
      goAdd() {
        let str = '/gest/' + this.negocio.id + '/almacen/productos/add';
        this.$router.push(str);
      },
    },
    created() {
      this.id = this.$route.params.idProducto;
      if (this.isAdd) {
        let a_nombre = [];
        let a_descripcion = [];
        for (var lang of this.idiomas) {
          let aux_1 = { lang: lang.value, text: '' };
          let aux_2 = { lang: lang.value, text: '' };
          a_nombre.push(aux_1);
          a_descripcion.push(aux_2);
          this.$store.commit('productos/setOpcionesEditadas', []);
          this.$store.commit('productos/setProductoEditando', null);
        }
        this.nombreIdiomas = a_nombre;
        this.descripcionIdiomas = a_descripcion;
      } else {
        let found = this.$store.state.productos.productosArray.find(
          (e) => e.id == this.id
        );
        if (found) {
          console.log(found);
          this.caractSeleccionadas = found.caractSeleccionadas;
          this.paneles = found.paneles ? found.paneles : [];
          this.nombreIdiomas = found.nombre ? found.nombre : found.name;
          this.nombreValidar = found.nombre ? found.nombre : found.name;

          this.descripcionIdiomas = found.descripcion
            ? found.descripcion
            : found.description;

          this.descripcionInterna = found.descripcionInterna
            ? found.descripcionInterna
            : '';
          this.nombreTpv = found.nombreTpv ? found.nombreTpv : '';
          this.codigoLector = found.codigoLector ? found.codigoLector : '';
          this.nombreValidar = this.nombreValidar;
          this.categoria = found.categoria;
          this.categoriaTpv = !!found.categoriaTpv ? found.categoriaTpv : null;
          this.imagenSrc = found.imagen;
          this.modificador = !!found.modificador;
          this.individualPedible = !!found.individualPedible;
          this.porPeso = !!found.porPeso;
          this.orden = found.orden;
          this.grupoModificador = found.grupoModificador
            ? found.grupoModificador
            : null;

          this.ocultarImagen = found.ocultarImagen
            ? found.ocultarImagen
            : false;
          this.tieneOpciones = found.tieneOpciones;
          this.precio = found.precioGlobal ? found.precioGlobal : 0;
          this.$store.commit('productos/setOpcionesEditadas', found.opciones);
          this.$store.commit('productos/setProductoEditando', found);
        } else {
          this.goAdd();
        }
      }
    },
    mounted() {
      this.$store.dispatch('productos/getModificadores');
      this.$store.dispatch('productos/getGruposModificadores');

      this.categoria = this.$store.state.productos.categoriaFiltrar;
    },
  };
</script>

<style></style>
